<script lang="ts" setup>
import { ChevronRightIcon } from '@radix-icons/vue';
import { cn } from '@/utils';
import type { BreadcrumbSeparatorProps } from '.';

const props = defineProps<BreadcrumbSeparatorProps>();
</script>

<template>
	<li
		role="presentation"
		aria-hidden="true"
		:class="
			cn(
				'flex items-center font-matter-sq text-xl leading-normal tracking-[-0.4px] text-primary-light-1 [&>svg]:size-3.5',
				props.class
			)
		"
	>
		<slot> / </slot>
	</li>
</template>
